export default {
	setUser(state, data) {
		if (data) {
			state.userInfo = data;
			state.isLogged = true;
		}
	},
	unsetUser(state) {
		state.userInfo = {};
		state.isLogged = false;
	}
};
